import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

type Command = {
  name: string;
  description: string;
};

async function postExpenseCategory(spaceId: string, command: Command) {
  const { data: user } = await apiClient.auth.getUser();

  if (!user.user) {
    throw new Error('Votre session a expiré, reconnectez-vous.');
  }

  const { data, error } = await apiClient
    .from('expense_categories')
    .insert({
      name: command.name,
      description: command.description,
      user_id: user.user.id,
      space_id: spaceId,
    })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function usePostExpenseCategory() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: (command: Command) => postExpenseCategory(currentSpace!.id, command),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.categories(currentSpace!.id) });
      enqueueSnackbar('Catégorie créée.', 'success');
    },
  });
}
